import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Dashboard = lazy(() => import("./Dashboard"));
const AboutUs = lazy(() => import("./AboutUs"));
const SignIn = lazy(() => import("./SignIn"));
const Admin = lazy(() => import("./Admin"));
const BookOfAccounts = lazy(() => import("./BookOfAccounts"));
const Report = lazy(() => import("./Report"));
const UserManagement = lazy(() => import("./UserManagement"));
const Transaction = lazy(() => import("./Transaction"));
const GeneralJournal = lazy(() => import("./GeneralJournal"));
const SeeTAccount = lazy(() => import("./SeeTAccount"));
const GeneralLedger = lazy(() => import("./GeneralLedger"));
const TrialBalance = lazy(() => import("./TrialBalance"));
const CashBook = lazy(() => import("./CashBook"));
const IncomeStatementWeb = lazy(() => import("./IncomeStatement"));
const FinancialPosition = lazy(() => import("./FinancialPosition"));
const CashFlow = lazy(() => import("./CashFlow"));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div style={{ padding: "16px" }}>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/signin" element={<SignIn />} />

          <Route path="/admin" element={<Admin />} />
          <Route path="/book-of-accounts" element={<BookOfAccounts />} />
          <Route path="/book-of-accounts/:section" element={<BookOfAccounts />} />
          <Route path="/report" element={<Report />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/transaction" element={<Transaction />} />
          <Route path="/general-journal" element={<GeneralJournal />} />
          <Route path="/t-account" element={<SeeTAccount />} />
          <Route path="/general-ledger" element={<GeneralLedger />} />
          <Route path="/trial-balance" element={<TrialBalance />} />
          <Route path="/cash-book" element={<CashBook />} />
          <Route path="/income-statement" element={<IncomeStatementWeb />} />
          <Route path="/financial-position" element={<FinancialPosition />} />
          <Route path="/cash-flow" element={<CashFlow />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;